export default __webpack_public_path__ + "static/media/img--living-dining-1.31896a84.jpg";